import React from 'react';
import { trpc } from '@/utils/trpc-client';
import { useCampaignContext } from '@/features/campaigns/campaign-context';
import { ProposalContextProvider } from '@/features/proposals/proposal-context';
import { Route, Routes } from 'react-router-dom';
import { ProposalLineItemPage } from '@/features/line-items/proposal-line-item-page';
import { ProposalPage } from '@/features/proposals/proposal-page';

export function ProposalRoutes() {
  const { campaign } = useCampaignContext();
  const { proposal_id } = campaign;
  const proposal = trpc.getProposal.useQuery({ proposal_id });
  const lineItems = trpc.getProposalLineItems.useQuery({ proposal_id });
  const diff = trpc.proposalDiff.useQuery({ proposal_id });

  return (
    <ProposalContextProvider proposal={proposal} lineItems={lineItems} diff={diff}>
      <Routes>
        <Route index element={<ProposalPage />} />
        <Route path="lineitems/:lineItemId" element={<ProposalLineItemPage />} />
      </Routes>
    </ProposalContextProvider>
  );
}
